import React from 'react'
import { BreadCrumb } from 'primereact/breadcrumb'
import { MenuItem } from 'primereact/menuitem'
import { useNavigate } from 'react-router-dom'

export type Crumb = { label: string; to?: string }

const BreadcrumbsNav: React.FC<{ items: Crumb[]; includeHome?: boolean }> = ({ items, includeHome = true }) => {
  const navigate = useNavigate()

  const home: MenuItem = {
    icon: 'pi pi-home',
    command: () => navigate('/')
  }

  const model: MenuItem[] = items.map((item) => ({
    label: item.label,
    command: item.to ? () => navigate(item.to!) : undefined,
  }))

  if (!items.length && !includeHome) return null

  return (
    <BreadCrumb
      model={model}
      home={includeHome ? home : undefined}
      className="border-none p-0 bg-transparent mb-3 text-sm"
    />
  )
}

export default BreadcrumbsNav

